// shell/nav.ts — the typed left-rail navigation registry (16 items; the A4 spec §6
// set of 11 plus Feedback, added when the feedback board shipped, plus Videos and
// Live — slice-4-xl reversed the prior "Phase-2, post-backend" omission for both
// (they're frontend placeholders now, same as every other not-yet-backed route),
// plus Support (Growth slice, 1.21.60).
// Monetization remains intentionally omitted.
// Non-nav routes (e.g. /creators-hub, /council, /more) live under BareLayout in router.tsx, not in this rail registry.

import type { IconName } from '@/icons';

/** Which live hook count drives a nav item's badge (if any). */
export type NavBadge = 'notifications' | 'dm' | 'group';

export interface NavItem {
  label: string;
  path: string;
  icon: IconName;
  badge?: NavBadge;
  staffOnly?: boolean;
  /**
   * Fix-round item 21 (1.21.60 adversarial review): destinations that require
   * a session — hidden from the rail for a signed-out visitor (Rail.tsx
   * filters on this), instead of showing a full rail where most links just
   * bounce the guest to /signin on click. Home/Explore/Support (no flag) are
   * the only genuinely public destinations this slice built guest UI for.
   * Communities is public on the backend too but deliberately left OUT —
   * no guest-facing UI was built for it this slice.
   */
  authOnly?: boolean;
}

export const NAV_ITEMS: NavItem[] = [
  { label: 'Home',          path: '/',              icon: 'home' },
  { label: 'Explore',       path: '/explore',       icon: 'compass' },
  { label: 'Videos',        path: '/videos',        icon: 'video',        authOnly: true },
  { label: 'Live',          path: '/live',          icon: 'radio',        authOnly: true },
  { label: 'Notifications', path: '/notifications', icon: 'bell',  badge: 'notifications', authOnly: true },
  { label: 'DMs',           path: '/messages',      icon: 'mail',  badge: 'dm',            authOnly: true },
  { label: 'Groups',        path: '/groups',        icon: 'users', badge: 'group',         authOnly: true },
  { label: 'Bookmarks',     path: '/bookmarks',     icon: 'bookmark',     authOnly: true },
  { label: 'Premium',       path: '/premium',       icon: 'crown',        authOnly: true },
  { label: 'Communities',   path: '/communities',   icon: 'users-round',  authOnly: true },
  { label: 'Profile',       path: '/profile',       icon: 'user',         authOnly: true },
  { label: 'More',          path: '/more',          icon: 'more-horizontal', authOnly: true },
  { label: 'Feedback',      path: '/feedback',      icon: 'feedback',     authOnly: true },
  { label: 'Support',       path: '/support',       icon: 'support' },
  { label: 'Council',       path: '/council',       icon: 'shield',       authOnly: true },
  { label: 'Owner',         path: '/owner',         icon: 'gauge',  staffOnly: true },
];
